"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCardCharges = checkCardCharges;
exports.formatCurrency = exports.convertPrice = void 0;
exports.getCurrencySymbol = getCurrencySymbol;
exports.handleCardFeePayments = handleCardFeePayments;
var _global = _interopRequireDefault(require("global"));
var _constants = require("../constants");
/**
 * amount - The amount in CENTS
 */
var convertPrice = exports.convertPrice = function convertPrice(amount) {
  var baseCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EUR';
  var currency = arguments.length > 2 ? arguments[2] : undefined;
  var rates = arguments.length > 3 ? arguments[3] : undefined;
  var exchangeRate = 1;
  var deprecatedRates = _global["default"].etv; // We used to store this in window
  var currencyKey = "".concat(baseCurrency).concat(currency);
  var prefixedKey = "fxrate".concat(currencyKey);
  if (rates && rates[currencyKey]) {
    exchangeRate = rates[currencyKey];
  } else if (deprecatedRates && deprecatedRates[prefixedKey]) {
    exchangeRate = deprecatedRates[prefixedKey];
  }
  return Math.round(amount * exchangeRate);
};

/**
 *
 * @param {*} money - The amount
 * @param {*} baseCurrency - Order currency
 * @param {*} currency - The currency to be displayed/converted to
 * @param {*} round - if we should round the amount
 * @param {*} rates - dictionary of fx rates
 */
var formatCurrency = exports.formatCurrency = function formatCurrency() {
  var money = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8000;
  var baseCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EUR';
  var currency = arguments.length > 2 ? arguments[2] : undefined;
  var round = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var rates = arguments.length > 4 ? arguments[4] : undefined;
  // Use the same as baseCurrency if not specified, otherwise USD will be displayed in EUR
  currency = currency || baseCurrency;
  var amount = convertPrice(money * 100, baseCurrency, currency, rates) / 100;
  var showCurrency = currency || baseCurrency;
  if (round) {
    amount = amount > 0 ? Math.ceil(amount).toFixed(2) : Math.floor(amount).toFixed(2);
  }
  if (typeof Intl === 'undefined' || !Intl.NumberFormat) {
    console.warn('Intl is not found, using simple polyfill');
    var symbol = getCurrencySymbol(currency);
    return "".concat(symbol).concat(amount);
  }
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: showCurrency,
    minimumFractionDigits: round ? 0 : 2
  }).format(amount);
};
function getCurrencySymbol(currency) {
  var symbol = '€';
  if (currency === 'GBP') {
    symbol = '£';
  } else if (currency === 'USD') {
    symbol = '$';
  } else if (currency === 'AUD') {
    symbol = 'A$';
  } else if (currency === 'CAD') {
    symbol = 'CA$';
  }
  return symbol;
}
function checkCardCharges(cardType, cardScheme, country) {
  if (country === 'GB') {
    return 0;
  }
  var cardCharges = _global["default"] && _global["default"].localStorage.creditCardCharges !== 'undefined' && JSON.parse(_global["default"].localStorage.creditCardCharges);
  if (!cardCharges) {
    return 0;
  }
  if (cardType.toLowerCase() === _constants.CREDIT_CARD_TYPES.CREDIT.toLowerCase()) {
    if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.VISA.toLowerCase()) {
      return cardCharges.credit_card_charge_visa;
    } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.MASTERCARD.toLowerCase()) {
      return cardCharges.credit_card_charge_mastercard;
    } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.AMEX.toLowerCase()) {
      return cardCharges.credit_card_charge_amex;
    }
    return cardCharges.fallback_credit_card_charge;
  }
  if (cardType.toLowerCase() === _constants.CREDIT_CARD_TYPES.DEBIT.toLowerCase()) {
    if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.VISA.toLowerCase()) {
      return cardCharges.debit_card_charge_visa;
    } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.MASTERCARD.toLowerCase()) {
      return cardCharges.debit_card_charge_mastercard;
    } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.AMEX.toLowerCase()) {
      return cardCharges.debit_card_charge_amex;
    }
  }
  return 0;
}
function handleCardFeePayments(payments) {
  if (payments.some(function (payment) {
    return payment.ourReference === _constants.CREDIT_CARD_FEE_REFERENCE;
  })) {
    var cardFeePayments = payments.filter(function (payment) {
      return payment.ourReference === _constants.CREDIT_CARD_FEE_REFERENCE;
    });
    var _loop = function _loop() {
      var _cardFeePayments$i;
      var parentId = (_cardFeePayments$i = cardFeePayments[i]) === null || _cardFeePayments$i === void 0 || (_cardFeePayments$i = _cardFeePayments$i.parent) === null || _cardFeePayments$i === void 0 ? void 0 : _cardFeePayments$i.id;
      var paymentIndex = payments.findIndex(function (payment) {
        return payment.id === parentId;
      });
      if (paymentIndex >= 0) {
        payments[paymentIndex].feePayment = cardFeePayments[i];
      }
    };
    for (var i = 0; i < cardFeePayments.length; i++) {
      _loop();
    }
  }
  return payments;
}